import { toast } from 'sonner';

// Fuente única de verdad del embudo delivery para notificaciones in-app del
// cliente. Combina order.status + order.delivery_status en una posición única
// (más alta = más avanzada) para poder detectar saltos de estado por sondeo.
const STAGE_BY_STATUS = {
  pending: 0,
  confirmed: 0,
  in_preparation: 1,
  preparing: 1,
  ready: 2,
};

const STAGE_BY_DELIVERY_STATUS = {
  assigned: 3,
  on_the_way: 4,
  nearby: 5,
  arrived: 6,
  delivered: 7,
};

const STAGE_EVENT = {
  1: 'in_preparation',
  2: 'ready',
  3: 'assigned',
  4: 'on_the_way',
  5: 'nearby',
  6: 'arrived',
  7: 'delivered',
};

// Mensajes mostrados al cliente (tabla acordada en el plan)
const NOTIF_LABELS = {
  in_preparation: { type: 'info', message: '🍳 Tu pedido se está preparando' },
  ready: { type: 'info', message: '📦 Tu pedido está listo para entrega' },
  assigned: { type: 'info', message: '🛵 Repartidor asignado a tu pedido' },
  on_the_way: { type: 'info', message: '🛵 ¡Tu pedido va en camino!' },
  nearby: { type: 'info', message: '📍 Tu repartidor está cerca de tu dirección' },
  arrived: { type: 'warning', message: '🔔 Tu repartidor ha llegado' },
  delivered: { type: 'success', message: '✅ ¡Pedido entregado! Que lo disfrutes' },
  cancelled: { type: 'error', message: '❌ Tu pedido fue cancelado' },
};

// Firma compacta del par (status, delivery_status) para diff por sondeo
export const statusKey = (order) => `${order.status || ''}|${order.delivery_status || ''}`;

// Posición en el embudo; -1 = cancelado (terminal especial)
const stageOf = ({ status, delivery_status: deliveryStatus }) => {
  if (status === 'cancelled') return -1;
  if (deliveryStatus === 'delivered' || status === 'delivered' || status === 'completed') return 7;
  if (deliveryStatus && deliveryStatus in STAGE_BY_DELIVERY_STATUS) {
    return STAGE_BY_DELIVERY_STATUS[deliveryStatus];
  }
  if (status && status in STAGE_BY_STATUS) return STAGE_BY_STATUS[status];
  return 0;
};

export const isActiveDeliveryOrder = (order) => (
  order.order_type === 'delivery' && !['delivered', 'completed', 'cancelled'].includes(order.status)
);

// Devuelve la clave del evento más avanzado alcanzado desde prevKey (una sola
// notificación por tick aunque el repartidor salte estados), o null si no hay
// nada nuevo. La cancelación se reporta siempre con prioridad.
export const getNewEvents = (order, prevKey) => {
  const curStage = stageOf(order);
  if (curStage === -1) return 'cancelled';
  const [prevStatus = '', prevDelivery = ''] = String(prevKey || '').split('|');
  const prevStage = stageOf({ status: prevStatus, delivery_status: prevDelivery });
  if (prevStage === -1 || curStage <= prevStage) return null;
  return STAGE_EVENT[curStage] || null;
};

// Dispara el toast sonner correspondiente al evento (description: nº de orden
// para distinguir cuando hay varias órdenes activas)
export const showDeliveryToast = (eventKey, order) => {
  const label = NOTIF_LABELS[eventKey];
  if (!label || typeof toast[label.type] !== 'function') return;
  toast[label.type](label.message, {
    description: order.order_number ? `Orden #${order.order_number}` : undefined,
    duration: 6000,
  });
};
